export const getUser = (state) => {
	return state.user;
};

export const getUserData = (state) => {
	return state.user.userData;
};
